import React, { useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messageError, messageToast } from '../../utils/define';
import { addKhoaAction } from '../../store/reducers/khoa';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

const schema = yup.object().shape({
    maKhoa: yup.string().required(messageError.emptyMessage),
    name: yup.string().required(messageError.emptyMessage)
});

const DMKhoaAdd = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const handleCreate = async (values) => {
        const model = values;

        try {
            const result = await dispatch(addKhoaAction(model));
            if (result.payload !== 200) {
                toast.error(messageToast.messageToastCreateError);
            } else {
                setIsLoading(true);
                toast.success(messageToast.messageToastCreateSuccess);
                history.goBack();
            }
        } catch (error) {
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm Khoa</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        maKhoa: '',
                        name: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>

                            {/* Mã khoa */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">Mã khoa *</Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Mã khoa"
                                        type="text"
                                        name="maKhoa"
                                        value={values.maKhoa}
                                        onChange={handleChange}
                                        isInvalid={!!errors.maKhoa}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.maKhoa}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            {/* Tên khoa */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">Tên khoa *</Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Tên khoa"
                                        type="text"
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                        isInvalid={!!errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.name}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            {/* Buttons */}
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>

                                        &nbsp;&nbsp;&nbsp;

                                        <Button onClick={() => history.goBack()} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>

                        </Form>
                    )}
                </Formik>

                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default DMKhoaAdd;
